import { createFileRoute, Navigate } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { EmployeeAssistancesPage } from 'src/modules/automations/components/pages/employees/assistances/assistances.page';
import { EMPLOYEE_ASSISTANCE_ROUTE_PERMISSIONS } from 'src/modules/automations/constants/employee-assistance.constants';
import { assistancesSearchSchema } from 'src/modules/automations/schemas/employees/assistances.schema';
import Loading from 'src/modules/shared/components/atoms/loading';
import { useHasPermissions } from 'src/modules/shared/hooks/auth';

export const Route = createFileRoute('/employees/assistances')({
  component: EmployeeAssistancesRoute,
  validateSearch: (search) => assistancesSearchSchema.parse(search),
});

function EmployeeAssistancesRoute() {
  const { hasPermission, loading } = useHasPermissions([
    ...EMPLOYEE_ASSISTANCE_ROUTE_PERMISSIONS,
  ]);

  if (loading) return <Loading size="lg" />;
  if (!hasPermission) return <Navigate to="/" />;

  return (
    <AuthenticateRoute>
      <EmployeeAssistancesPage />
    </AuthenticateRoute>
  );
}
